var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDeliveryBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1DBB90;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.3,54h-7V14h-48v65h-7v3h28v4h13h3h29V54H76.3z M68.4,57h4.9v6.8l-2.5-0.8l-2.5,0.8L68.4,57z M24.3,79V17h42v37h-0.9 H55.3v11h-13v14H24.3z M55.3,83h-10V68h10V83z M84.3,83h-26V65v-8h7.1l-0.1,10.8l5.5-1.7l5.5,1.9V57h8V83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.2,44.6c-2.3,0-4.2,1.9-4.2,4.2c0,2.3,1.9,4.2,4.2,4.2s4.2-1.9,4.2-4.2C36.4,46.5,34.5,44.6,32.2,44.6z M32.2,50 c-0.7,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2c0.7,0,1.2,0.5,1.2,1.2S32.8,50,32.2,50z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 77.4,
    y: 76,
    width: 4.9,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 72.3,
    y: 76,
    width: 3.1,
    height: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeliveryBox);
export default __webpack_public_path__ + "static/media/icon-delivery-box.9beedcbe.svg";
export { ForwardRef as ReactComponent };